export * from '@core/js/hooks/user/server.js';

export const fetchSignedUserToken = async ({ apiKey, userId, username }, token) => {
    try {
        const params = new URLSearchParams();
        params.append('user[id]', userId);
        params.append('app', apiKey);
        params.append('user[name]', username || '');
        params.append('playtech_token', token);

        const url = `https://captainup.com/mechanics/v2/playtech_auth?${params.toString()}`;
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });

        if (!response.ok) {
            return null;
        }

        const res = await response.json();

        return res.data;
    } catch (error) {
        console.error('Failed to fetch Captain Up balance:', error);
        return null;
    }
};

export const getCaptainUpUserData = async ({ apiKey, userId, username, clientToken }, signedUser) => {
    const params = new URLSearchParams();
    params.append('user[id]', userId);
    params.append('signed_user', signedUser);
    params.append('clientToken', clientToken);
    params.append('user[name]', username);

    const url = `https://captainup.com/mechanics/v2/app/${apiKey}/players`;

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: params
    });

    if (!response.ok) {
        return null;
    }

    return await response.json();
};
